import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class OnlineOfflineService {
  private onlineStatus$ = new BehaviorSubject<boolean>(navigator.onLine);

  constructor(private snackBar: MatSnackBar) {
    window.addEventListener('online', () => this.updateOnlineStatus(true));
    window.addEventListener('offline', () => this.updateOnlineStatus(false));

    // Show initial connection status message
    this.onlineStatus$.subscribe((status) => {
      const message = status ? 'Conexão restaurada. Sincronizando dados...' : 'Você está offline.';
      this.snackBar.open(message, 'Fechar', { duration: 3000 });
    });
  }

  private updateOnlineStatus(status: boolean): void {
    console.log(`Status de conexão: ${status ? 'online' : 'offline'}`);
    this.onlineStatus$.next(status);
  }

  // Expose online status as an observable
  get onlineStatus(): Observable<boolean> {
    return this.onlineStatus$.asObservable();
  }

  // Utility method to check if the app is online
  isOnline(): boolean {
    return this.onlineStatus$.value;
  }
}